import { createApp } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import store from './store';
import './i18n-react';
import i18nVue from './i18n-vue';
import PrimeVue from 'primevue/config';
import Dropdown from 'primevue/dropdown';
import OverlayPanel from 'primevue/overlaypanel';

import 'primevue/resources/themes/viva-dark/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

const app = createApp(App);

// Register global components
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('Dropdown', Dropdown);
app.component('OverlayPanel', OverlayPanel);

// Use plugins
app.use(router);
app.use(store);
app.use(i18nVue);
app.use(PrimeVue);

// Mount the app
app.mount('#app');
